const DASHBOARD_VIEW = 'DASHBOARD_VIEW';
const APPROVAL_VIEW = 'APPROVAL_VIEW';
const APPROVAL_EDIT = 'APPROVAL_EDIT';

const COMPANY_VIEW = 'COMPANY_VIEW';
const COMPANY_EDIT = 'COMPANY_EDIT';
const COMPANY_ACCESS_RIGHT_VIEW = 'COMPANY_ACCESS_RIGHT_VIEW';
const COMPANY_ACCESS_RIGHT_EDIT = 'COMPANY_ACCESS_RIGHT_EDIT';
const COMPANY_WHITE_LABEL_VIEW = 'COMPANY_WHITE_LABEL_VIEW';
const COMPANY_BRANCH_VIEW = 'COMPANY_BRANCH_VIEW';
const COMPANY_USER_VIEW = 'COMPANY_USER_VIEW';
const COMPANY_USER_IMPERSONATE = 'COMPANY_USER_IMPERSONATE';
const COMPANY_USER_CREDIT_TRANSFER = 'COMPANY_USER_CREDIT_TRANSFER';
const COMPANY_ASSIGN = 'COMPANY_ASSIGN';

const FEATURE_GROUP_VIEW = 'FEATURE_GROUP_VIEW';
const FEATURE_GROUP_EDIT = 'FEATURE_GROUP_EDIT';

const BUNDLE_VIEW = 'BUNDLE_VIEW';
const BUNDLE_EDIT = 'BUNDLE_EDIT';

const COMPANY_CONSUMER_ENGAGEMENT_VIEW = 'COMPANY_CONSUMER_ENGAGEMENT_VIEW';
const COMPANY_CONSUMER_ENGAGEMENT_DISBURSEMENT_VIEW = 'COMPANY_CONSUMER_ENGAGEMENT_DISBURSEMENT_VIEW';
const COMPANY_CONSUMER_ENGAGEMENT_DISBURSEMENT_BALANCE = 'COMPANY_CONSUMER_ENGAGEMENT_DISBURSEMENT_BALANCE';
const COMPANY_CONSUMER_ENGAGEMENT_DISBURSEMENT_TRANSACTION_LIMIT = 'COMPANY_CONSUMER_ENGAGEMENT_DISBURSEMENT_TRANSACTION_LIMIT';
const COMPANY_CONSUMER_ENGAGEMENT_DISBURSEMENT_NOTIFICATION_EDIT = 'COMPANY_CONSUMER_ENGAGEMENT_DISBURSEMENT_NOTIFICATION_EDIT';
const COMPANY_CONSUMER_ENGAGEMENT_REPORT_VIEW = 'COMPANY_CONSUMER_ENGAGEMENT_REPORT_VIEW';

const PARTNER_AND_RESELLER_VIEW = 'PARTNER_AND_RESELLER_VIEW';
const PARTNER_AND_RESELLER_ADD = 'PARTNER_AND_RESELLER_ADD';

const EMAIL_LOG_VIEW = 'EMAIL_LOG_VIEW';
const EMAIL_LOG_SEND = 'EMAIL_LOG_SEND';

const MASTER_CONTROL_EDIT = 'MASTER_CONTROL_EDIT';

const ADMIN_VIEW = 'ADMIN_VIEW';
const ADMIN_EDIT = 'ADMIN_EDIT';
const ADMIN_ROLE_VIEW = 'ADMIN_ROLE_VIEW';
const ADMIN_ROLE_EDIT = 'ADMIN_ROLE_EDIT';
const ADMIN_COMPANY_GROUP_VIEW = 'ADMIN_COMPANY_GROUP_VIEW';
const ADMIN_COMPANY_GROUP_EDIT = 'ADMIN_COMPANY_GROUP_EDIT';

const DATA_SUMMARY_VIEW = 'DATA_SUMMARY_VIEW';

const SUPPORT_ANALYTICS_VIEW = 'SUPPORT_ANALYTICS_VIEW';
const SLA_SETTINGS_VIEW = 'SLA_SETTINGS_VIEW';
const SLA_SETTINGS_EDIT = 'SLA_SETTINGS_EDIT';
const SUPPORT_TICKET_ACCESS = 'SUPPORT_TICKET_ACCESS';
const SUPPORT_TICKET_MANAGE_ALL = 'SUPPORT_TICKET_MANAGE_ALL';
const SUPPORT_TICKET_ACKNOWLEDGE = 'SUPPORT_TICKET_ACKNOWLEDGE';
const SUPPORT_TICKET_CREATE = 'SUPPORT_TICKET_CREATE';
const SUPPORT_TICKET_ASSIGN_AGENT = 'SUPPORT_TICKET_ASSIGN_AGENT';
const SUPPORT_TICKET_ESCALATE = 'SUPPORT_TICKET_ESCALATE';
const SUPPORT_TICKET_CHANGE_STATUS = 'SUPPORT_TICKET_CHANGE_STATUS';
const SUPPORT_TICKET_SET_PRIORITY = 'SUPPORT_TICKET_SET_PRIORITY';

const AccessRights = {
  DASHBOARD_VIEW,
  APPROVAL_VIEW,
  APPROVAL_EDIT,
  COMPANY_VIEW,
  COMPANY_EDIT,
  COMPANY_ACCESS_RIGHT_VIEW,
  COMPANY_ACCESS_RIGHT_EDIT,
  COMPANY_WHITE_LABEL_VIEW,
  COMPANY_BRANCH_VIEW,
  COMPANY_USER_VIEW,
  COMPANY_USER_CREDIT_TRANSFER,
  COMPANY_ASSIGN,
  COMPANY_CONSUMER_ENGAGEMENT_VIEW,
  COMPANY_CONSUMER_ENGAGEMENT_DISBURSEMENT_VIEW,
  COMPANY_CONSUMER_ENGAGEMENT_DISBURSEMENT_BALANCE,
  COMPANY_CONSUMER_ENGAGEMENT_DISBURSEMENT_TRANSACTION_LIMIT,
  COMPANY_CONSUMER_ENGAGEMENT_DISBURSEMENT_NOTIFICATION_EDIT,
  COMPANY_CONSUMER_ENGAGEMENT_REPORT_VIEW,
  PARTNER_AND_RESELLER_VIEW,
  PARTNER_AND_RESELLER_ADD,
  EMAIL_LOG_VIEW,
  EMAIL_LOG_SEND,
  MASTER_CONTROL_EDIT,
  ADMIN_VIEW,
  ADMIN_EDIT,
  ADMIN_ROLE_VIEW,
  ADMIN_ROLE_EDIT,
  ADMIN_COMPANY_GROUP_VIEW,
  ADMIN_COMPANY_GROUP_EDIT,
  COMPANY_USER_IMPERSONATE,
  DATA_SUMMARY_VIEW,
  FEATURE_GROUP_VIEW,
  FEATURE_GROUP_EDIT,
  SUPPORT_ANALYTICS_VIEW,
  SLA_SETTINGS_VIEW,
  SLA_SETTINGS_EDIT,
  SUPPORT_TICKET_ACCESS,
  SUPPORT_TICKET_MANAGE_ALL,
  SUPPORT_TICKET_ACKNOWLEDGE,
  SUPPORT_TICKET_CREATE,
  SUPPORT_TICKET_ASSIGN_AGENT,
  SUPPORT_TICKET_ESCALATE,
  SUPPORT_TICKET_CHANGE_STATUS,
  SUPPORT_TICKET_SET_PRIORITY,
  BUNDLE_VIEW,
  BUNDLE_EDIT,
};

export default AccessRights;
